export default __webpack_public_path__ + "images/DH.27b6cba.png";